import * as types from "../types"
import * as trafficApi from "../../api/core/traffic.dd"
import { store } from "../store"
import Vue from "vue"
import { read } from "fs";

const state = {
  currentTrafficData:[],
}

const getters = {
  [types.CURRENT_TRAFFIC_DATA]: (state) => {
    return state.currentTrafficData
  },
}

const mutations = {
  [types.CURRENT_TRAFFIC_DATA]: (state, payload) => {  
    state.currentTrafficData = payload.data  
  },
}

const actions = {
    [types.CURRENT_TRAFFIC_DATA]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
            trafficApi.getCurrentTraffic().then((res) => {
                
                // if traffic not active or configured empty traffic data and resolve
                if(res.data == "TRAFFIC_API_SETTINGS_NOT_CONFIGURED" || res.data == "TRAFFIC_API_NOT_ACTIVE" || res.data == "TRAFFIC_API_CREDENTIALS_NOT_CONFIGURED"){
                    console.log("Traffic data disabled. Reason: "+res.data);
                    commit(types.CURRENT_TRAFFIC_DATA, [])
                    resolve(true);
                }
                else{ // commit data and return data in resolved
                    commit(types.CURRENT_TRAFFIC_DATA, res.data)
                    resolve(true)
                }
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    }
}

export default {
  state,
  getters,
  mutations,
  actions
}
